export enum Boards {
    MPO = 'ad913cf6-8ef1-4a35-873f-d29f7d77c7ec',
    MNN = '4d504254-2e59-4501-a3e4-f4cb8f94a706',
  }